import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import MobileFormInput from 'components/MobileFormInput';
import { useFormik } from 'formik';
import * as yup from 'yup';
import styles from './index.module.scss';
import clsx from 'clsx';

export interface PhoneFormProps {
  className?: string;
  onContinue: (phoneNumber: string) => void;
}

export const validationSchema = yup.object({
  phoneNumber: yup
    .number()
    .typeError('Phone number not valid')
    .required('Phone number is required'),
});

export function PhoneForm(props: PhoneFormProps) {
  const formik = useFormik({
    validationSchema,
    initialValues: { phoneNumber: '' },
    onSubmit: (values) => {
      props.onContinue(values.phoneNumber);
    },
  });
  return (
    <form
      onSubmit={formik.handleSubmit}
      className={clsx(styles.form, props.className)}
    >
      <MobileFormInput
        name="phoneNumber"
        formik={formik}
        inputProps={{
          placeholder: 'Phone Number',
          type: 'tel',
        }}
      />
      <ButtonWithArrowIcon type="submit" className={styles.confirmButton}>
        Continue
      </ButtonWithArrowIcon>
    </form>
  );
}

export default PhoneForm;
